define('models/disposable',["require", "exports"], function (require, exports) {
    "use strict";
});

